import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../../../services/commande-client/data.service';

@Component({
  selector: 'app-brouillon-bon-sortie',
  templateUrl: './brouillon-bon-sortie.component.html',
  styleUrls: ['./brouillon-bon-sortie.component.scss']
})
export class BrouillonBonSortieComponent implements OnInit {

    constructor(private dataService: DataService) {}

    ngOnInit(): void {
        this.dataService.filterOrdersByStatus('Tous');
    }

}
